import { useDispatch } from "react-redux";
import { dispatchItemToRedux } from "Redux/Actions/CommonActions";
import ReducerTypes from "Redux/Types/ReducerTypes";
import "./style.css";

const Pagination = ({ current_page, last_page, first_page_url, catBox }) => {
  const handleScroll = (ref) => {
    window.scrollTo({
      behavior: "smooth",
      top: ref.current.offsetTop,
    });
  };

  const dispatch = useDispatch();
  const previousBtnProps = {
    disabled: current_page === 1,
  };

  const nextBtnProps = {
    disabled: current_page === last_page,
  };

  const nextPage = () => {
    handleScroll(catBox);
    dispatch(
      dispatchItemToRedux({
        type: ReducerTypes.PARAMS,
        payload: {
          page: current_page + 1,
        },
      })
    );
  };
  const previousPage = () => {
    handleScroll(catBox);
    dispatch(
      dispatchItemToRedux({
        type: ReducerTypes.PARAMS,
        payload: {
          page: current_page - 1,
        },
      })
    );
  };
  const lastPage = () => {
    handleScroll(catBox);
    dispatch(
      dispatchItemToRedux({
        type: ReducerTypes.PARAMS,
        payload: {
          page: last_page,
        },
      })
    );
  };
  const firstPage = () => {
    handleScroll(catBox);
    dispatch(
      dispatchItemToRedux({
        type: ReducerTypes.PARAMS,
        payload: {
          page: first_page_url,
        },
      })
    );
  };

  return (
    <div className="pagination d-flex justify-content-center align-items-center mt-4">
      <button
        onClick={previousPage}
        className="hover-pagination ms-2 border p-2 rounded bg-light"
        {...previousBtnProps}
      >
        قبلی
      </button>
      <button
        className="hover-pagination border p-2 rounded mx-2 bg-white"
        onClick={firstPage}
      >
        صفحه اول
      </button>
      ......<strong className=" border p-2 rounded mx-2">{current_page}</strong>
      ....{" "}
      <button
        className="hover-pagination border p-2 rounded mx-2 bg-white"
        onClick={lastPage}
      >
        صفحه اخر
      </button>
      <button
        onClick={nextPage}
        className="hover-pagination me-2  border p-2 rounded bg-light"
        {...nextBtnProps}
      >
        بعدی
      </button>
    </div>
  );
};

export default Pagination;
